// extracted by mini-css-extract-plugin
module.exports = {"artwork":"artwork_artwork__2FQqA"};